/*
 * Application State should be all within this file.
 */

const app = {
  state: {
    temperatureUnit: "K",
    preset: null
  },
  mutations: {
    SET_TEMPERATURE_UNIT(state, payload) {
      if (payload !== "C" && payload !== "F" && payload !== "K") {
        throw new Error("Invalid temperature unit");
      }
      state.temperatureUnit = payload;
    },
    SET_PRESET(state, payload) {
      state.preset = payload;
    }
  },
  actions: {
    setTemperatureUnit({ commit }, payload) {
      console.log("setTemperatureUnit", payload);
      commit("SET_TEMPERATURE_UNIT", payload);
    },
    setPreset({ commit }, payload) {
      console.log("setPreset", payload);
      commit("SET_PRESET", payload);
    },
    clearPreset({ commit }) {
      commit("SET_PRESET", null);
    },
    mapFromDatastore({ commit, state }, payload) {
      /*
       * This is called whenever the Datastore/entry changes.
       * This is an opportunity for you to map stored values
       * back into your state.
       */
      let _payload = "";
      try {
        _payload = JSON.parse(payload);
      } catch (e) {
        _payload = payload;
      }

      /*
       * Call a mutation to put your datastore payload into your app state
       */
      commit("SET_EXAMPLE", _payload?.example ?? state.example);
      commit(
        "SET_EXAMPLE_FORM_FIELDS",
        _payload?.exampleFormFields ?? state.exampleFormFields
      );
    }
  },
  getters: {
    temperatureUnit: (state) => state.temperatureUnit,
    preset: (state) => state.preset,
    mapToDatastore(state) {
      /*
       * Datastore Payload is only used whenever you're using the
       * Datastore (or Datasheets). This is an object
       */

      let payload = {
        example: state.example,
        exampleFormFields: state.exampleFormFields
      };

      payload = JSON.stringify(payload);
      return payload;
    }
  }
};

export default app;
